export const SAVE_INVOICES_LIST = 'SAVE_INVOICES_LIST'; 
export const SAVE_INVOICE_DETAILS = 'SAVE_INVOICE_DETAILS'; 